import React from 'react';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';
import { Link } from 'react-router-dom';
import Icon from '../components/common/Icon';

const departments = [
  { id: 'organizzazione', title: 'Organizzazione', head: 'Marco Rossi', icon: 'Settings', color: 'var(--color-primary)' },
  { id: 'comunicazione', title: 'Comunicazione', head: 'Giulia Bianchi', icon: 'Megaphone', color: '#f59e0b' },
  { id: 'scuola-universita', title: 'Scuola e Università', head: 'Luca Verdi', icon: 'GraduationCap', color: '#3b82f6' },
  { id: 'lavoro', title: 'Lavoro', head: 'Elena Neri', icon: 'Briefcase', color: '#10b981' },
  { id: 'ambiente', title: 'Ambiente', head: 'Matteo Gialli', icon: 'Leaf', color: '#059669' },
  { id: 'diritti', title: 'Diritti', head: 'Sara Viola', icon: 'Heart', color: '#ec4899' },
  { id: 'esteri-europa', title: 'Esteri ed Europa', head: 'Antonio Blu', icon: 'Globe', color: '#2563eb' },
  { id: 'enti-locali', title: 'Enti Locali', head: 'Federica Arancio', icon: 'Landmark', color: '#d97706' }
];

const DipartimentiPage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Organizzazione', path: '/organizzazione' }, { label: 'Dipartimenti' }];
  
  return (
    <Layout>
      <HeroPage 
        breadcrumbs={breadcrumbs} 
        overline="Struttura Nazionale" 
        title="Dipartimenti" 
        subtitle="Il motore operativo dei Giovani Democratici. Ogni dipartimento approfondisce temi specifici e coordina l'iniziativa politica nazionale." 
      />
      
      <section className="section">
        <div className="container">
          <div className="grid grid-4 gap-6">
            {departments.map((dept, idx) => (
              <Link 
                to={`/dipartimento/${dept.id}`} 
                key={dept.id}
                className="card-premium reveal reveal--scale"
                style={{ 
                  textDecoration: 'none', 
                  color: 'inherit',
                  padding: 'var(--space-8)',
                  background: '#fff',
                  borderRadius: 'var(--radius-2xl)',
                  border: '1px solid var(--color-border-subtle)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  '--delay': `${idx * 0.05}s`
                }}
              >
                <div style={{ 
                  width: '64px', 
                  height: '64px', 
                  borderRadius: 'var(--radius-xl)', 
                  background: `${dept.color}10`, 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  color: dept.color,
                  marginBottom: 'var(--space-6)'
                }}>
                  <Icon name={dept.icon} size={32} />
                </div>
                <h3 className="h5 mb-2">{dept.title}</h3>
                <p className="text-small text-secondary mb-4">Responsabile: <br/><strong>{dept.head}</strong></p>
                <div className="mt-auto pt-4 border-t w-full" style={{ borderColor: 'var(--color-border-subtle)' }}>
                  <span className="text-small font-bold text-primary flex items-center justify-center gap-2">
                    Vedi dettagli <Icon name="ArrowRight" size={14} />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default DipartimentiPage;
